import { Group } from '@/router/group.model';
import {
  adminBusinessOwnership,
  adminBusinessesList,
  // adminCampaignsList,
  adminCustomersList,
  adminDashboard,
  adminFlagsList,
  adminOnlineTransactions,
  adminTwismWallet,
  adminCoinStore,
  adminAddEvent,
  adminOffers,
  adminTicketRequest,
  adminIdentifyCustomers,
  adminTriggerBroadcasts,
  adminKeywordsList
} from '@/router/routes';

const adminRoutes = [
  adminDashboard,
  adminOnlineTransactions,
  adminFlagsList,
  // adminCampaignsList,
  adminBusinessesList,
  adminCustomersList,
  adminBusinessOwnership,
  adminAddEvent,
  adminTwismWallet,
  adminOffers,
  adminKeywordsList,
  adminIdentifyCustomers,
  adminTriggerBroadcasts
];

const coinStoreRoutes = [adminCoinStore];
const ticketRequestRoutes = [adminTicketRequest];

const adminGroup = new Group('Admin', 'admin', adminRoutes, {
  superRoot: true,
  icon: 'activities'
});

const coinStoreGroup = new Group('Coin Store', 'admin/store', coinStoreRoutes, {
  superRoot: true,
  icon: 'store'
});

const ticketGroup = new Group(
  'Ticket Request',
  'admin/ticket-request',
  ticketRequestRoutes,
  {
    superRoot: true,
    icon: 'customer-center'
  }
);

export { adminGroup, coinStoreGroup, ticketGroup };
export default adminGroup;
